import * as yup from 'yup';

export const CreatePaymentMethodFormValidation = yup.object().shape({
    description: yup.string().required('Campo é obrigatório')
});